<template>
  <div class="credit-card-display">
    <div class="card credit-card">
      <p class="numbers">{{ creditCard.dropdownLabel }}</p>
      <p class="name">
        <span v-if="creditCard.cardType == 'Business'" class="badge badge-primary">Business Card</span>
        <span v-if="creditCard.cardType == 'Personal'" class="badge badge-warning">Personal Card</span>
        <br>
        <button type="button" class="mt-2 btn btn-xs btn-primary" @click="changeCardType(creditCard.uuid)">
          <span class="fa" :class="{ 'fa-user': creditCard.cardType === 'Business', 'fa-briefcase': creditCard.cardType === 'Personal' }"></span>
          Change to {{ creditCard.cardType == 'Business' ? 'Personal' : 'Business' }} Card
        </button>
        <br>
        <button class="mt-2 btn btn-xs btn-info" type="button" @click="editNickname(creditCard.uuid)">
          <i class="fa fa-edit"></i> Edit Card Nickname
        </button>
      </p>
      <p class="expiry">
        Expiry: {{ new Date(creditCard.expiry).getMonth() + 1 }}/{{ new Date(creditCard.expiry).getFullYear() }}
        <span v-if="new Date() > new Date(creditCard.expiry)" class="red">*Expired*</span>
      </p>
      <span :class="'fa-2x ' + creditCard.icon.replace('fa ', 'fab ')"></span>
      <div class="actions">
        <button class="btn btn-xs btn-danger" type="button" @click="deleteCard(creditCard.uuid)">
          <i class="fa fa-trash-alt fa-lg"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import {
  EDIT_CREDIT_CARD_TYPE,
  EDIT_CREDIT_CARD_NICKNAME,
  DELETE_CREDIT_CARD
} from '@/vuex/types'
export default {
  name: 'CreditCardDisplay',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    creditCard () {
      return {
        ...this.object,
        ...this.updatedCard
      }
    }
  },
  data () {
    return {
      updatedCard: {}
    }
  },
  methods: {
    async executeAction (action, payload) {
      let result = await this[action](payload)
      if (result && result.updated) this.updatedCard = result.updated
    },
    deleteCard (cardUuid) {
      this.executeAction(DELETE_CREDIT_CARD, cardUuid)
    },
    changeCardType (cardUuid) {
      this.executeAction(EDIT_CREDIT_CARD_TYPE, cardUuid)
    },
    editNickname (cardUuid) {
      this.executeAction(EDIT_CREDIT_CARD_NICKNAME, cardUuid)
    },
    ...mapActions([
      EDIT_CREDIT_CARD_TYPE,
      EDIT_CREDIT_CARD_NICKNAME,
      DELETE_CREDIT_CARD
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/CreditCardDisplay.vue